export const rows = [
  {
    id: 1,
    employeeName: "Zayden Cole",
    designation: "Picker",
    deviceNumber: "PDA001",
    totalOrders: 5,
    priorityOrders: 2,
    orderLines: 8,
    totalItems: 13,
    status: "Present",
  },
  {
    id: 2,
    employeeName: "Livia Skye",
    designation: "Picker",
    deviceNumber: "PDA002",
    totalOrders: 3,
    priorityOrders: 2,
    orderLines: 13,
    totalItems: 23,
    status: "Present",
  },
  {
    id: 3,
    employeeName: "Amara Sloane",
    designation: "Picker",
    deviceNumber: "PDA003",
    totalOrders: 13,
    priorityOrders: 1,
    orderLines: 23,
    totalItems: 33,
    status: "Present",
  },
  {
    id: 4,
    employeeName: "Cassius Reid",
    designation: "Picker",
    deviceNumber: "PDA004",
    totalOrders: 11,
    priorityOrders: 5,
    orderLines: 20,
    totalItems: 33,
    status: "Present",
  },
  {
    id: 5,
    employeeName: "Leslie Alexander",
    designation: "Picker",
    deviceNumber: "PDA005",
    totalOrders: 4,
    priorityOrders: "-",
    orderLines: 5,
    totalItems: 9,
    status: "Present",
  },
  {
    id: 6,
    employeeName: "Ronald Richards",
    designation: "Picker",
    deviceNumber: "PDA006",
    totalOrders: 40,
    priorityOrders: "-",
    orderLines: 65,
    totalItems: 112,
    status: "Present",
  },
  {
    id: 7,
    employeeName: "Jenny Wilson",
    designation: "Picker",
    deviceNumber: "PDA007",
    totalOrders: 25,
    priorityOrders: "-",
    orderLines: 50,
    totalItems: 200,
    status: "Absent",
  },
];
